import routerOptions0 from "/build/cc0930d0-05c3-43d6-add7-5a1ee4cf4b47/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}